import { Grid } from "@mui/material";
import { IWhatsAppTemplate } from "../../../redux/whatsappTemplate/whatsappTemplate.types";
import { MarketCampaignContext } from "../../market-campaign/MarketCampaign.context-state";
import { mockCampaignContext } from "../../../helpers/mockCampaignContext";
import { Step3MarketCampaignChannel } from "../../market-campaign/campaign-steps";
import { Dialog } from "../../../components/Dialogs/Dialog";
import {useMediaQuery,useTheme} from '@mui/material';

interface ISelectWhatsappTemplateProps {
  open: boolean;
  toNumber: string;
  isFromStartConversation?: boolean;
  isFromQuickReply?: boolean;
  onClose: () => void;
  onSelect?: (template: IWhatsAppTemplate) => void;
}

export const SelectWhatsappTemplate = (props: ISelectWhatsappTemplateProps) => {
  const {
    open,
    toNumber,
    onClose,

    isFromStartConversation,
    isFromQuickReply,
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      size={isMobile ? "md" : "xl"}
      open={open}
      onClose={onClose}
      title={"Select Whatsapp Template"}
      titleSx={{
        typography: {
          fontSize: isMobile ? "1.1rem" : undefined,
          whiteSpace: isMobile ? "normal" : undefined,
          overflow: isMobile ? "visible" : undefined,
          textOverflow: isMobile ? "clip" : undefined,
          lineHeight: isMobile ? "1.3" : undefined,
        },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MarketCampaignContext.Provider value={mockCampaignContext}>
            <Step3MarketCampaignChannel
              isFromChatModule={{
                toNumber,
                isFromStartConversation,
                isFromQuickReply,
                onClose,
              }}
            />
          </MarketCampaignContext.Provider>
        </Grid>
      </Grid>
    </Dialog>
  );
};
